import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HammerModule } from '@angular/platform-browser';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { MatTableModule } from '@angular/material/table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { GlobalVariables } from './data/global-variables';
import { FloatingVisorComponent } from './floating-visor/floating-visor.component';
import { CornerstoneLiteDirective } from './floating-visor/cornerstone-lite.directive';
import { BookPdfFlipbookComponent } from './tabs/book-pdf-flipbook/book-pdf-flipbook.component';
import { AnimationsComponent } from './utils/animations/animations.component';
import { ShareStudyComponent } from './utils/share-study/share-study.component';
import { AlertComponent } from './utils/alert/alert.component';
import { DownloadInstructionsComponent } from './utils/download-instructions/download-instructions.component';
import { VisorContextMenuComponent } from './utils/visor-context-menu/visor-context-menu.component';
import { AuthTokenInterceptor } from './auth/auth-token.interceptor';
import { BookPdfFlipbookVerticalComponent } from './tabs/book-pdf-flipbook/book-pdf-flipbook-vertical/book-pdf-flipbook-vertical.component';
import { BookPdfFlipbookLandscapeComponent } from './tabs/book-pdf-flipbook/book-pdf-flipbook-landscape/book-pdf-flipbook-landscape.component';
import { SideOptionsDesktopComponent } from './utils/side-options-desktop/side-options-desktop.component';
import { SideOptionsMobileComponent } from './utils/side-options-mobile/side-options-mobile.component';
import { ContactImageComponent } from './utils/contact-image/contact-image.component';
import { HistoricDemoComponent } from './demo/historic-demo/historic-demo.component';
import { SeriesScrollbarComponent } from './floating-visor/series-scrollbar/series-scrollbar.component';
import { FloatingTipsComponent } from './floating-tips/floating-tips.component';
import { CookieService } from 'ngx-cookie-service';
import { AccessLocatorComponent } from './tabs/access-locator/access-locator.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DownloadModalComponent } from './utils/download-modal/download-modal.component';
import { DownloadModalMobileComponent } from './utils/download-modal/download-modal-mobile/download-modal-mobile.component';
import { InfoStudyComponent } from './utils/info-study/info-study.component';
import { QRCodeModule } from 'angularx-qrcode';
import { AiReportComponent } from './utils/ai-report/ai-report.component';
import { HistoricalModalMobileComponent } from './utils/historical-modal-mobile/historical-modal-mobile.component';
import { RecoverMailComponent } from './tabs/recover-mail/recover-mail.component';
import { LoginComponent } from './tabs/login/login.component';
import { BookListComponent } from './tabs/book-list/book-list.component';
import { DownloadStudyModalComponent } from './tabs/book-list/download-study-modal/download-study-modal.component';
import { StudyHistoricModalComponent } from './tabs/book-list/study-historic-modal/study-historic-modal.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { ReportViewerComponent } from './tabs/book-list/report-viewer/report-viewer.component';
import { AccessSelectionPopupComponent } from './tabs/access-locator/access-selection-popup/access-selection-popup.component';
import { MobileHistoryComponent } from './tabs/book-pdf-flipbook/book-pdf-flipbook-vertical/mobile-history/mobile-history.component';
import { MobileReportViewComponent } from './tabs/book-pdf-flipbook/book-pdf-flipbook-vertical/mobile-report-view/mobile-report-view.component';
import { BottomNavComponent } from './tabs/book-pdf-flipbook/book-pdf-flipbook-vertical/bottom-nav/bottom-nav.component';
import { SideMenuComponent } from './header/side-menu/side-menu.component';
import { VerticalHeaderComponent } from './header/vertical-header/vertical-header.component';
import { HorizontalHeaderComponent } from './header/horizontal-header/horizontal-header.component';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    FloatingVisorComponent,
    CornerstoneLiteDirective,
    BookPdfFlipbookComponent,
    AnimationsComponent,
    ShareStudyComponent,
    AlertComponent,
    DownloadInstructionsComponent,
    VisorContextMenuComponent,
    BookPdfFlipbookVerticalComponent,
    BookPdfFlipbookLandscapeComponent,
    SideOptionsDesktopComponent,
    SideOptionsMobileComponent,
    ContactImageComponent,
    HistoricDemoComponent,
    SeriesScrollbarComponent,
    FloatingTipsComponent,
    AccessLocatorComponent,
    DownloadModalComponent,
    DownloadModalMobileComponent,
    InfoStudyComponent,
    AiReportComponent,
    HistoricalModalMobileComponent,
    RecoverMailComponent,
    LoginComponent,
    BookListComponent,
    DownloadStudyModalComponent,
    StudyHistoricModalComponent,
    SidenavComponent,
    ReportViewerComponent,
    AccessSelectionPopupComponent,
    MobileHistoryComponent,
    MobileReportViewComponent,
    BottomNavComponent,
    SideMenuComponent,
    VerticalHeaderComponent,
    HorizontalHeaderComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HammerModule,
    PdfViewerModule,
    QRCodeModule ,
    MatTableModule,
    NgbModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      }
    }),
  ],
  providers: [
    GlobalVariables,
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    CookieService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }

